import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { primary_color } from '../../../Helper/uiHelper'
import { set } from 'date-fns'

const checkIsFilterApplied = (savedFilter) => {
  if (!savedFilter) return false
  let isFilterApplied = false
  if (savedFilter?.rec_per_page) {
    delete savedFilter['rec_per_page']
  }
  Object.keys(savedFilter)?.map((key) => {
    if (savedFilter[key]) {
      isFilterApplied = true
    }
  })
  return isFilterApplied
}
const MarkAllLockerCoded = ({ gridRelatedData }) => {
  const dispacth = useDispatch()
  const savedFilter = useSelector((state) => state.CMS.savedFilters)

  const [isModelOpen, setIsModelOpen] = useState(false)
  const [isNotCodedModelOpen, setIsNotCodedModelOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const currentRow = useSelector((state) => state.CMS.currentRow)

  const currentSavedFilter = savedFilter?.[gridRelatedData?.tableGrid?.name]
  const displayDataIds = gridRelatedData?.gridData?.data?.map((item) => item?.id)
  const isFilterApplied = checkIsFilterApplied(currentSavedFilter)

  const onApprove = (notCoded) => {
    let payload = {
      item_date_time_id: currentRow?.[0]?.id,
      coded: notCoded ? false : true,
    }
    if (isFilterApplied) {
      payload = {
        ...payload,
        items: displayDataIds,
        code_displayed_locker: true,
      }
    }

    setIsLoading(true)
    request('renewal-locations/approve-locker-code', 'POST', payload).then((res) => {
      isSuccessResponse(res, 'Lockers marked as coded!')
      setIsLoading(false)
      dispacth(fetchUpdateApiData())
      setIsModelOpen(false)
      setIsNotCodedModelOpen(false)
    })
  }

  return (
    <div>
      <Button size='sm' color='success' className='mr-2 mb-2' onClick={() => setIsModelOpen(true)} disabled={isLoading}>
        {isFilterApplied ? 'Mark displayed lockers coded' : 'Mark All Lockers Coded'}
      </Button>
      <Button size='sm' color='warning' onClick={() => setIsNotCodedModelOpen(true)} disabled={isLoading} className='text-white mb-2'>
        {isFilterApplied ? 'Mark displayed lockers Not coded' : 'Mark All Lockers Not Coded'}
      </Button>
      <Modal
        isOpen={isModelOpen}
        centered={true}
        toggle={() => {
          setIsModelOpen(!isModelOpen)
        }}
        style={{ width: '30rem', boxShadow: 'none', maxWidth: '50rem' }}>
        <ModalHeader style={{ backgroundColor: '#FFF', border: 'none', padding: '2rem' }}>
          <div className='p font-weight-bold text-center' style={{ color: primary_color }}>
            {isFilterApplied
              ? 'You are about to Mark displayed locker Coded. Do you want to proceed?'
              : 'You are about to Mark All Lockers Coded. Do you want to proceed?'}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className='d-flex justify-content-between'>
            <button
              className='btn text-white rounded-pill mt-2'
              type='button'
              onClick={() => {
                onApprove()
              }}
              style={{ background: primary_color, fontWeight: 700, width: '48%' }}>
              Yes
            </button>
            <button
              className='btn rounded-pill mt-2 text-danger border-danger'
              type='button'
              onClick={() => {
                setIsModelOpen(!isModelOpen)
              }}
              style={{ fontWeight: 700, width: '48%' }}>
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={isNotCodedModelOpen}
        centered={true}
        toggle={() => {
          setIsNotCodedModelOpen(!isNotCodedModelOpen)
        }}
        style={{ width: '30rem', boxShadow: 'none', maxWidth: '50rem' }}>
        <ModalHeader style={{ backgroundColor: '#FFF', border: 'none', padding: '2rem' }}>
          <div className='p font-weight-bold text-center' style={{ color: primary_color }}>
            {isFilterApplied
              ? 'You are about to Mark displayed locker not Coded. Do you want to proceed?'
              : 'You are about to Mark All Lockers note Coded. Do you want to proceed?'}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className='d-flex justify-content-between'>
            <button
              className='btn text-white rounded-pill mt-2'
              type='button'
              onClick={() => {
                onApprove(true)
              }}
              style={{ background: primary_color, fontWeight: 700, width: '48%' }}>
              Yes
            </button>
            <button
              className='btn rounded-pill mt-2 text-danger border-danger'
              type='button'
              onClick={() => {
                setIsNotCodedModelOpen(!isNotCodedModelOpen)
              }}
              style={{ fontWeight: 700, width: '48%' }}>
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default MarkAllLockerCoded
